export default __webpack_public_path__ + "static/media/facebook.74b7bd52.webp";